import { updateItems } from '@/mocks/homepage';

const tagColors: Record<string, string> = {
  '新剧上线': 'bg-primary-100 text-primary-700',
  '即将上线': 'bg-accent-100 text-accent-800',
  '行业动态': 'bg-secondary-100 text-secondary-700',
  '票房捷报': 'bg-primary-100 text-primary-700',
  '片单发布': 'bg-accent-100 text-accent-800',
  '收视捷报': 'bg-primary-100 text-primary-700',
  '平台动态': 'bg-accent-100 text-accent-800',
  '开机快讯': 'bg-secondary-100 text-secondary-700',
  '政策资讯': 'bg-secondary-100 text-secondary-700',
};

export default function Updates() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-8 md:mb-10">
          <i className="ri-flashlight-line text-xl text-primary-500"></i>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            最新动态
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] top-2 bottom-2 w-px bg-background-200 hidden md:block"></div>
          <div className="space-y-0">
            {updateItems.map((item, idx) => (
              <div key={item.id} className="flex gap-4 md:gap-6 py-3.5 md:py-4 group cursor-pointer hover:bg-background-100/50 rounded-lg px-2 -mx-2 transition-colors">
                <div className="hidden md:flex flex-col items-center shrink-0 w-[30px] pt-1">
                  <div className={`w-3 h-3 rounded-full border-2 z-10 ${
                    idx === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-primary-300'
                  }`}></div>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 md:gap-3 flex-wrap mb-1">
                    <span className="text-xs text-foreground-400 shrink-0">{item.date}</span>
                    <span className="text-xs text-foreground-300 shrink-0">{item.time}</span>
                    <span className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-medium ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </p>
                </div>

                <div className="hidden sm:flex items-center shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-arrow-right-s-line text-foreground-400 text-lg"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}